import { useToast } from '@chakra-ui/react'
import { useState } from 'react'

import { getTokens } from './auth'

export type StatusType = 'success' | 'error'

export const useResetPassword = () => {
  const [sending, setSending] = useState(false)
  const toast = useToast()

  const sendPWResetRequest = (status: StatusType, userId: string) => {
    toast({
      title: `Password reset for ${userId} ${status === 'success' ? 'was successful' : 'failed'}`,
      status: status,
      duration: 3000,
    })
  }

  const resetPWRequest = async (userId?: string) => {
    setSending(true)
    const tokens = getTokens()
    const url = `${import.meta.env.VITE_API_URL}admin/users/${userId}/reset-password`

    if (!userId) {
      sendPWResetRequest('error', 'Unknown user')
    } else {
      try {
        const response = await fetch(url, {
          method: 'PUT',
          headers: { Authorization: `Bearer ${tokens?.accessToken}` },
        })
        if (response) {
          setSending(false)
          sendPWResetRequest(response.ok ? 'success' : 'error', userId)
        }
      } catch (error) {
        console.warn('Error resetting password', error) // eslint-disable-line no-console
        setSending(false)
        sendPWResetRequest('error', userId)
      }
    }
  }

  return {
    sending,
    resetPWRequest,
  }
}
